import { render, staticRenderFns } from "./Energy.vue?vue&type=template&id=0137f7fe&scoped=true&"
import script from "./Energy.vue?vue&type=script&lang=ts&"
export * from "./Energy.vue?vue&type=script&lang=ts&"
import style0 from "./Energy.vue?vue&type=style&index=0&id=0137f7fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0137f7fe",
  null
  
)

export default component.exports